import { Box, Grid, Link, Typography } from "@mui/material";
import React from "react";
import { COLORS } from "../../constants/colors";
import { GitHub, Instagram, LinkedIn, Public, Twitter } from "@mui/icons-material";

const Footer = () =>{
    return(
        <>
         <Box sx={{ flexGrow: 1 }} id="projects" className="section" style={{ backgroundColor: COLORS.primary }}>
        <Grid className="footer" container>
        <Grid item sm={4} className="section">
        <Link style={{backgroundColor:'#000'}} href='https://github.com/mjmaurya' className="social" color={COLORS.white}><GitHub/> GitHub</Link>
        </Grid>
        <Grid item sm={4} className="section">
        <Link style={{backgroundColor:'#0077B5'}} href='https://www.linkedin.com/in/mjmaurya' className="social" color={COLORS.white}><LinkedIn /> LinkedIn</Link>
                                
        </Grid>
        <Grid item sm={4} className="section">
        <Link style={{backgroundColor:'#1DA1F2'}} href='https://x.com/manojkushwaha__' className="social" color={COLORS.white} ><Twitter /> Twitter</Link>
        </Grid>
        <Grid item sm={4} className="section">
        <Link style={{backgroundColor:'#E4405F'}} href='https://www.instagram.com/mj.cs_/' className="social" color={COLORS.white} ><Instagram /> Instagram</Link>
        </Grid>
        <Grid item sm={4} className="section">
        <Link style={{backgroundColor:'#778DCA'}} href='https://www.codescript.in' className="social" color={COLORS.white} ><Public /> Blogs</Link>
        </Grid>
        <Grid item sm={4} className="section">
        
        </Grid>
        </Grid>
        </Box>
        </>
    )
}

export default Footer;